import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

const pageTitle = "Summary";

function createDataColumn(kpi, segments) {
    const dataColumn = new Map();

    for (let segment of segments) {
        for (let data of segment.data_records) {
            let key = data.timeframe_year ?? "__ERROR__";

            if (!dataColumn.has(key)) {
                dataColumn.set(key, { name: key, label: key });
            }
        }
    }
    return [...dataColumn.values()];
}

function createDataColumnValue(kpi, segments) {
    const dataValue = {};

    for (let segment of segments) {
        dataValue[segment.id] = { goal: {}, result: {} };
        for (let data of segment.data_records) {
            dataValue[segment.id]["goal"][data.timeframe_year] = data.expected_value_json?.value
                ? data.expected_value_json.value.toLocaleString()
                : "n/a";
            dataValue[segment.id]["result"][data.timeframe_year] = data.result_value_json?.value
                ? data.result_value_json.value.toLocaleString()
                : "n/a";
        }
    }
    return dataValue;
}

export default function KpiDataResult() {
    const [datas, setDatas] = useState([]);
    const { kpi } = useOutletContext();

    const kpiData = kpi?.data?.data;
    const segments = kpiData?.kpi_data_segments?.filter((x) => x.primary == true) ?? [];
    const dataColumn = createDataColumn(kpi, segments);
    const dataValue = createDataColumnValue(kpi, segments);

    const navigate = useNavigate();
    const handleNavigateEditGoal = (kpiId, segmentId) =>
        navigate(`/kpis/${kpiId}/data/goal/edit?segmentId=${segmentId}`);
    const handleNavigateEditResult = (kpiId, segmentId) =>
        navigate(`/kpis/${kpiId}/data/result/edit?segmentId=${segmentId}`);

    return (
        <Card variant="outlined">
            <CardHeader title={pageTitle}></CardHeader>

            <Divider variant="middle" />

            <CardContent sx={{ padding: 2 }}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{kpiData?.timeframe?.title}</TableCell>
                                {dataColumn.map((column) => (
                                    <TableCell key={column.name}>{column.label}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {/** TODO: loop (i in segments): */}
                            {segments.map((segment) => (
                                <React.Fragment key={segment.id}>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            {segment.data_segment_title} ({segment.data_unit})
                                        </TableCell>
                                        <TableCell colSpan={dataColumn.length}>
                                            <Stack direction="row" spacing={1}>
                                                <Button onClick={() => handleNavigateEditGoal(kpiData?.id, segment.id)}>
                                                    กำหนดเป้า
                                                </Button>
                                                <Button
                                                    onClick={() => handleNavigateEditResult(kpiData?.id, segment.id)}
                                                >
                                                    รายงานผล
                                                </Button>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" sx={{ paddingLeft: 5 }}>
                                            เป้า
                                        </TableCell>
                                        {dataColumn?.map((column) => (
                                            <TableCell key={column.name}>
                                                {dataValue[segment.id]["goal"][column.name]}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row" sx={{ paddingLeft: 5 }}>
                                            ผล
                                        </TableCell>
                                        {dataColumn?.map((column) => (
                                            <TableCell key={column.name}>
                                                {dataValue[segment.id]["result"][column.name]}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
}
